<app-bottom-sheet [(isOpen)]="isOpen"
                  [hasFooter]="false"
                  [isFullScreen]="false"
                  [preventOverlayClose]="false"
                  [contentTemplate]="assignSheetContent"
                  [headerTemplate]="assignSheetHeader"
                  data-testid="assign-items-to-trade-sheet">
</app-bottom-sheet>

<ng-template #assignSheetHeader>
  <div class="sheet-header"
       data-testid="assign-items-to-trade-header">
    <p class="sheet-title body-lg-bold">Assign {{ itemCount() }} Items to Trade</p>
  </div>
</ng-template>

<ng-template #assignSheetContent>
  <div class="assign-sheet-content"
       data-testid="assign-items-to-trade-content">

    <!-- Vendor dropdown -->
    <div class="form-field">
      <label for="assign-vendor-select"
             class="field-label body-md-bold">
        Vendor:
      </label>
      <app-select-field inputId="assign-vendor-select"
                        [options]="vendorOptions()"
                        [filter]="true"
                        filterBy="name"
                        [ngModel]="selectedVendorId()"
                        (ngModelChange)="onVendorChange($event)"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Vendor"
                        panelStyleClass="vendor-select-overlay"
                        testId="assign-vendor-select">
        <ng-template #selectOptionItem
                     let-option
                     let-label="label">
          @if (option.id === selfAssignedVendorId) {
            <span class="bqa-pinned-select-option"
                  data-testid="assign-to-me-option">{{ assignToMeLabel }}</span>
          } @else {
            {{ label }}
          }
        </ng-template>
      </app-select-field>
    </div>

    <!-- Send to: contacts (managed by send-to-contact). Self-assigned items are never sent to a trade partner. -->
    @if (selectedVendorId() !== null && !isAssignToMeSelected()) {
      <app-send-to-contact [contacts]="contactsForSelectedVendor()"
                           [externalVendorId]="selectedVendorId()!"
                           [externalFinancialCommunityId]="financialCommunityId()"
                           [vendorName]="selectedVendor()?.name ?? ''"
                           (selectionChange)="onSelectionChange($event)"
                           data-testid="assign-send-to-contact">
      </app-send-to-contact>
    }

    <!-- Due Date -->
    <div class="form-field due-date-field"
         data-testid="assign-due-date-field">
      <label for="assign-due-date"
             class="field-label body-md-bold">
        Due Date:
      </label>
      <p-datepicker id="assign-due-date"
                    [ngModel]="dueDate()"
                    (ngModelChange)="dueDate.set($event)"
                    [showIcon]="true"
                    icon="pi pi-calendar-clock"
                    dateFormat="mm/dd/yy"
                    placeholder="Select Date"
                    styleClass="w-full"
                    appendTo="body"
                    data-testid="assign-due-date" />
    </div>

    <!-- Action buttons -->
    <div class="action-buttons">
      @if (!isAssignToMeSelected()) {
        <p-button label="{{ isSending() ? 'Sending...' : 'Assign & Send' }}"
                  [loading]="isSending()"
                  type="button"
                  severity="contrast"
                  styleClass="bqa-primary-btn p-fullwidth-button"
                  [disabled]="!canAssign()"
                  (onClick)="onAssignAndSend()"
                  data-testid="assign-and-send-btn" />
      }

      <p-button label="{{ isSaving() ? 'Saving...' : 'Assign & Save' }}"
                [loading]="isSaving()"
                type="button"
                [outlined]="true"
                styleClass="bqa-primary-btn p-fullwidth-button body-lg-regular"
                [disabled]="!canAssign()"
                (onClick)="onAssignAndSave()"
                data-testid="assign-and-save-btn" />
    </div>

  </div>
</ng-template>